module.exports = "/_next/static/images/OgProduct-b5ed5f4bd907a8cba5bdb998f85de358.jpeg";